const KEY = 'swnav.recent';
const CAP = 3;

/** Most-recent-first node ids. Storage can be blocked or corrupt, so failure means empty. */
export const getRecent = (): number[] => {
  try {
    const raw = localStorage.getItem(KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed.filter((n) => typeof n === 'number').slice(0, CAP) : [];
  } catch {
    return [];
  }
};

export const pushRecent = (id: number): void => {
  try {
    const next = [id, ...getRecent().filter((n) => n !== id)].slice(0, CAP);
    localStorage.setItem(KEY, JSON.stringify(next));
  } catch {
    // Recents are a convenience; losing one must never break navigation.
  }
};
